import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const puzzelReroute = (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { query } = to;
  const {
    source,
    kundgrupp,
    organisationsnummer,
    personnummer,
    notfound,
    ticketid,
  } = query;

  if (source === "puzzel") {
    if (kundgrupp === "arbetsgivarforbund" || kundgrupp === "partsbolag") {
      return next();
    }
    if (organisationsnummer && !notfound) {
      return next({ name: "arbetsgivare", query });
    }
    if (personnummer && !notfound) {
      return next({ name: "anstalld", query });
    }
    if (ticketid && !isNaN(Number(ticketid))) {
      return next({
        query: {
          ...query,
          q: ticketid,
          source: undefined,
        },
      });
    }
  }

  return next();
};
